import React from "react";
import { XCircle } from "lucide-react";
import Seo from "@/components/Seo";
import { GoldBtn, OutlineBtn } from "@/components/Bits";
import { useDonate } from "@/context/DonateContext";

export default function PaymentCancel() {
  const { openDonate } = useDonate();
  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-32">
      <Seo title="Payment Cancelled" description="Your payment was cancelled." path="/payment/cancel" />
      <div className="w-full max-w-lg text-center" data-testid="payment-cancel">
        <XCircle className="mx-auto h-14 w-14 text-ivory2/60" />
        <h1 className="mt-6 font-serif text-4xl font-light text-ivory">No payment was made.</h1>
        <p className="mt-4 text-ivory2">Your checkout was cancelled and you have not been charged. Whenever you're ready, we'd be honored by your support.</p>
        <div className="mt-8 flex justify-center gap-4">
          <OutlineBtn to="/" testid="cancel-home">Return Home</OutlineBtn>
          <GoldBtn onClick={() => openDonate()} testid="cancel-retry">Try Again</GoldBtn>
        </div>
      </div>
    </div>
  );
}
